import { Routes, Route } from 'react-router-dom'
import { Suspense, lazy } from 'react'
import Layout from './components/layout/Layout'
import LoadingScreen from './components/ui/LoadingScreen'

// Lazy load pages for better performance
const Landing = lazy(() => import('./pages/Landing'))
const TutorialAcademy = lazy(() => import('./pages/TutorialAcademy'))
const Tutorials = lazy(() => import('./pages/Tutorials'))
const Marketplace = lazy(() => import('./pages/Marketplace'))
const Create = lazy(() => import('./pages/Create'))
const IDE = lazy(() => import('./pages/IDE'))
const FreelancerProfile = lazy(() => import('./pages/FreelancerProfile'))
const Chat = lazy(() => import('./pages/Chat'))
const PrivateChat = lazy(() => import('./pages/PrivateChat'))
const Profile = lazy(() => import('./pages/Profile'))
const Missions = lazy(() => import('./pages/Missions'))
const Affiliates = lazy(() => import('./pages/Affiliates'))
const Subscriptions = lazy(() => import('./pages/Subscriptions'))
const Settings = lazy(() => import('./pages/Settings'))
const Login = lazy(() => import('./pages/Login'))
const Register = lazy(() => import('./pages/Register'))
const AuthCallback = lazy(() => import('./pages/AuthCallback'))
const GuestCodes = lazy(() => import('./pages/GuestCodes'))
const RedeemCode = lazy(() => import('./pages/RedeemCode'))
const Admin = lazy(() => import('./pages/Admin'))
const AnimationsDemo = lazy(() => import('./pages/AnimationsDemo'))
const Whiteboard = lazy(() => import('./pages/Whiteboard'))

function App() {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Layout>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/tutorials" element={<TutorialAcademy />} />
          <Route path="/tutorials/legacy" element={<Tutorials />} />
          <Route path="/marketplace" element={<Marketplace />} />
          <Route path="/create" element={<Create />} />
          <Route path="/create/ide" element={<IDE />} />
          <Route path="/freelancer/:id" element={<FreelancerProfile />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/chat/private" element={<PrivateChat />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/missions" element={<Missions />} />
          <Route path="/affiliates" element={<Affiliates />} />
          <Route path="/subscriptions" element={<Subscriptions />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/guest-codes" element={<GuestCodes />} />
          <Route path="/redeem" element={<RedeemCode />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/animations" element={<AnimationsDemo />} />
          <Route path="/whiteboard" element={<Whiteboard />} />
        </Routes>
      </Layout>
    </Suspense>
  )
}

export default App
